import { render, staticRenderFns } from "./ImageCheckbox.vue?vue&type=template&id=4f55aec5&scoped=true&"
import script from "./ImageCheckbox.vue?vue&type=script&lang=ts&"
export * from "./ImageCheckbox.vue?vue&type=script&lang=ts&"
import style0 from "./ImageCheckbox.vue?vue&type=style&index=0&id=4f55aec5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f55aec5",
  null
  
)

export default component.exports